enum DefaultEvents {
  ON_PILET_INITIALIZED = 'oli_piral_onPiletInitialized',
  ON_ALL_PILETS_INITIALIZED = 'oli_piral_onAllPiletsInitialized',
  ON_PILET_ADDED_TO_PAGE = 'oli_piral_onPiletAddedToPage',
  ON_CONFIG_LOADED = 'oli_piral_onConfigLoaded',
  PAGE_CHANGE = 'oli_piral_pageChange'
}

export default DefaultEvents;